export const API_PREFIX = '/api';

export const API_ROUTES = {
    AUTHENTICATION_TOKEN: '/authentication_token',
    REFRESH_TOKEN: '/token/refresh',
    SIGNED_USER_DATA: '/signed_user_data',
    USERS: '/users',
    APPOINTMENTS: '/appointments',
    APPOINTMENT_REPORTS_VALUES: '/appointment_reports_values',
    CUSTOMERS: '/customers',
    WORKERS: '/workers',
    WORKER_REPORTS: '/worker_reports',
    YEARLY_REPORTS: '/yearly_reports',
    PLACES: '/places',
    ARTICLES: '/articles',
    PERCENTAGES: '/percentages',
    DIGITAL_RECORDS: '/digital_records',
    CUSTOMER_DIGITAL_RECORD: '/customer_digital_record',
    PRINT_CUSTOMER_DIGITAL_RECORD: '/print_customer_digital_record',
    PRINT_SINGLE_CUSTOMER_DIGITAL_RECORD: '/print_single_customer_digital_record',
    PRINT_RECORD: '/print_record',
    AREAS: '/areas',
    SUB_AREAS: '/sub_areas',
    THERAPIES: '/therapies',
    EXPENSES: '/expenses',
    EXPENSE_TYPES: '/expense_types',
    MLPS: '/mlps',
    MLP_LIST_PRINT: '/print/mlp_list',
    MLP_VALUES: '/mlp_values',
    MLP_LIST: '/mlp_list',
    PROTOCOLS: '/protocols',
    PRINT_PROTOCOLS: '/print_protocols',
    ADD_USER: '/add_user',
    ADD_USER_PASSWORD: '/add_user_password',
    CUSTOMERS_DAILY_COUNT: '/customer_daily_count',
    CUSTOMERS_MONTLY_COUNT_BY_WORKERS: '/customer_monthly_count_by_workers',
    APPOINTMENTS_MONTLY_COUNT_BY_WORKERS: '/appointments_monthly_count_by_workers',
    APPOINTMENTS_COUNT_BY_CUSTOMERS: '/appointments_count_by_customers',
    PRINT_APPOINTMENTS_COUNT_BY_CUSTOMERS: '/print/appointments_count_by_customers',
    COMPANIES: '/companies'
}
